var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-inner" }, [
        _c("img", {
          attrs: {
            src: require("../images/header-logo.png").default,
            alt: "Cary MacArthur",
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "quiz_app" } },
      [
        _vm.showResumePrompt
          ? _c("div", { staticClass: "resume-prompt" }, [
              _c("p", [
                _vm._v(
                  "\n        This browser has saved answers from an earlier session. Choose whether to continue\n        or start with a blank assessment.\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: { click: _vm.resumeSavedAnswers },
                  },
                  [_vm._v("Continue where I left off")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-start-fresh",
                    attrs: { type: "button" },
                    on: { click: _vm.discardSavedAnswers },
                  },
                  [_vm._v("Start over")]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.temperaments && _vm.questions && _vm.groups && !_vm.showResumePrompt
          ? _c("router-view")
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.temperaments && _vm.questions && _vm.groups && !_vm.showResumePrompt
      ? _c("div", { staticClass: "footer" }, [_vm._m(0)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-inner" }, [
      _c("div", { staticClass: "footer-text" }, [
        _vm._v("Compared to the C.O.R.E. Temperament model"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }